/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import CustomTooltip from '../../../common-components/CustomTooltip/CustomTooltip';
import userProfile from '../../../../images/icons/user.svg';
import { Tooltip } from '@mui/material';
import { formatNumber } from '../../../../utils/global';
import '../styles/engagementRateGraph.scss';

export default function EngagementRateCard({ engrateData, engagementRate, username, profileImage }) {
  const maxCount = useMemo(
    () =>
      engrateData.reduce((max, obj) => {
        return obj.total > max.total ? obj : max;
      }).total,
    [engrateData]
  );

  const [graphData, setGraphData] = useState(null);
  const [medianRange, setMedianRange] = useState('');
  const [userRange, setUserRange] = useState('');

  const createGraphData = () => {
    const data = engrateData.map((d, i) => {
      let median_range = d?.median ? true : false;
      let user_range = engagementRate > d.min && engagementRate < d.max ? true : false;

      let formatedRange = `${isNaN(d.min) ? '0%' : (d.min * 100).toFixed(2) + '%' || 0} ${isNaN(d.max) ? '+' : '-'} ${
        isNaN(d.max) ? '' : (d.max * 100).toFixed(2) + '%' || d.max + 0.15
      } ${d.median ? '(Median)' : ''}`;

      if (median_range) {
        setMedianRange(i);
      }
      if (i === engrateData.length - 1 && engagementRate > d.min) {
        setUserRange(i);
        formatedRange += `(${username})`;
      }
      if (user_range) {
        setUserRange(i);
        formatedRange += `(${username})`;
      }
      return {
        range: formatedRange,
        total: d.total,
      };
    });
    setGraphData(data);
  };

  useEffect(() => {
    createGraphData();
  }, [engrateData, engagementRate, username]);

  if (!engrateData || !graphData) {
    return null;
  }

  return (
    <div className="demographics-card">
      <div style={{ marginBottom: 40 }}>
        <h2>
          Engagement vs. Median in Niche{' '}
          <CustomTooltip arrow title="How their engagement rate measures up against other similar ones">
            <InfoIcon sx={{ color: '#667085', fontSize: 18 }} />
          </CustomTooltip>
          <span className="eng-rate">{(engagementRate * 100).toFixed(2)}%</span>
        </h2>
      </div>
      <div className="engagement-rate-graph-container">
        <div className="top-bars">
          {graphData?.map((data, index) => (
            <PopoverTooltip range={data.range} total={data.total} key={index}>
              <div style={{ height: ((data.total * 100) / maxCount) * 2.35 }} className="inner-bar">
                <div style={{ height: ((data.total * 100) / maxCount) * 2.35 }} className="main-bar" />
              </div>
            </PopoverTooltip>
          ))}
        </div>

        <div className="median-text" style={{ left: `${(medianRange / 2) * 10 + 5}%` }}>
          <p>Median</p>
        </div>
        <div className="profile-image-container" style={{ left: `${(medianRange / 2) * 10 + 5}%` }}>
          <img src={userProfile} alt="" className="profile-image" />
        </div>
        <div className="profile-image-container" style={{ left: `${(userRange / 2) * 10 + 5}%` }}>
          <img src={profileImage} alt="" className="profile-image" />
        </div>
        <div className="bottom-row">
          <div style={{ width: `${(userRange / 2) * 10}%` }}></div>
        </div>
      </div>
    </div>
  );
}

function PopoverTooltip({ range, total, children, arrow = true, placement = 'top' }) {
  return (
    <Tooltip
      title={
        <div className="engrate-graph-tooltip">
          <h3>{range}</h3>
          <p>{formatNumber(total)} accounts</p>
        </div>
      }
      componentsProps={{
        tooltip: {
          sx: {
            borderRadius: '999px',
            fontSize: '11px',
            lineHeight: 1.6,
            fontFamily: 'Poppins',
            backgroundColor: '#fafafa',
            color: '#353535',
            fontWeight: 500,
            padding: '12px 24px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
          },
        },
        arrow: {
          sx: { color: '#fafafa' },
        },
      }}
      arrow={arrow}
      placement={placement}>
      {children}
    </Tooltip>
  );
}
